<template>
  <div>
      <CsPrivacyPolicy v-if="locale === 'cs'" />
      <DePrivacyPolicy v-else-if="locale === 'de'" />
      <EsPrivacyPolicy v-else-if="locale === 'es'" />
      <FrPrivacyPolicy v-else-if="locale === 'fr'" />
      <HuPrivacyPolicy v-else-if="locale === 'hu'" />
      <ItPrivacyPolicy v-else-if="locale === 'it'" />
      <JaPrivacyPolicy v-else-if="locale === 'ja'" />
      <NlPrivacyPolicy v-else-if="locale === 'nl'" />
      <PlPrivacyPolicy v-else-if="locale === 'pl'" />
      <PtPrivacyPolicy v-else-if="locale === 'pt'" />
      <RuPrivacyPolicy v-else-if="locale === 'ru'" />
      <SvPrivacyPolicy v-else-if="locale === 'sv'" />
      <TrPrivacyPolicy v-else-if="locale === 'tr'" />
      <UkPrivacyPolicy v-else-if="locale === 'uk'" />
      <CnPrivacyPolicy v-else-if="locale === 'cn' || locale === 'zh'" />
      <ArPrivacyPolicy v-else-if="locale === 'ar'" />
      <KoPrivacyPolicy v-else-if="locale === 'ko'" />
      <EnPrivacyPolicy v-else />
  </div>
</template>

<script>
import RuPrivacyPolicy from '@/components/policy/locales/ru/RuPrivacyPolicy.vue'
import EnPrivacyPolicy from '@/components/policy/locales/en/EnPrivacyPolicy.vue'
import CsPrivacyPolicy from '@/components/policy/locales/cs/CsPrivacyPolicy.vue'
import DePrivacyPolicy from '@/components/policy/locales/de/DePrivacyPolicy.vue'
import EsPrivacyPolicy from '@/components/policy/locales/es/EsPrivacyPolicy.vue'
import FrPrivacyPolicy from '@/components/policy/locales/fr/FrPrivacyPolicy.vue'
import HuPrivacyPolicy from '@/components/policy/locales/hu/HuPrivacyPolicy.vue'
import ItPrivacyPolicy from '@/components/policy/locales/it/ItPrivacyPolicy.vue'
import JaPrivacyPolicy from '@/components/policy/locales/ja/JaPrivacyPolicy.vue'
import NlPrivacyPolicy from '@/components/policy/locales/nl/NlPrivacyPolicy.vue'
import PlPrivacyPolicy from '@/components/policy/locales/pl/PlPrivacyPolicy.vue'
import PtPrivacyPolicy from '@/components/policy/locales/pt/PtPrivacyPolicy.vue'
import SvPrivacyPolicy from '@/components/policy/locales/sv/SvPrivacyPolicy.vue'
import TrPrivacyPolicy from '@/components/policy/locales/tr/TrPrivacyPolicy.vue'
import UkPrivacyPolicy from '@/components/policy/locales/uk/UkPrivacyPolicy.vue'
import CnPrivacyPolicy from '@/components/policy/locales/cn/CnPrivacyPolicy.vue'
import ArPrivacyPolicy from '@/components/policy/locales/ar/ArPrivacyPolicy.vue'
import KoPrivacyPolicy from '@/components/policy/locales/ko/KoPrivacyPolicy.vue'
export default {
  name: 'PrivacyPolicy',
  components: {
    ArPrivacyPolicy,
    UkPrivacyPolicy,
    TrPrivacyPolicy,
    SvPrivacyPolicy,
    PtPrivacyPolicy,
    PlPrivacyPolicy,
    NlPrivacyPolicy,
    ItPrivacyPolicy,
    HuPrivacyPolicy,
    FrPrivacyPolicy,
    EsPrivacyPolicy,
    RuPrivacyPolicy,
    EnPrivacyPolicy,
    CsPrivacyPolicy,
    DePrivacyPolicy,
    JaPrivacyPolicy,
    CnPrivacyPolicy,
    KoPrivacyPolicy,
  },
  props: {
    locale: {
      type: String,
      required: true,
    },
  }
}
</script>

<style scoped>

</style>
